// eslint-disable-next-line import/prefer-default-export
export enum DropdownItemID {
  PublishCustomFields = "publishCustomFields",
  CheckMappings = "checkMappings",
}
